import { render, staticRenderFns } from "./SampleDataBadge.vue?vue&type=template&id=0c0ad7d4&scoped=true"
import script from "./SampleDataBadge.vue?vue&type=script&lang=ts"
export * from "./SampleDataBadge.vue?vue&type=script&lang=ts"
import style0 from "./SampleDataBadge.vue?vue&type=style&index=0&id=0c0ad7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ad7d4",
  null
  
)

export default component.exports